import type { ButtonProps } from '@mui/material'
import { Button, CircularProgress } from '@mui/material'
import React from 'react'

interface SpinnerButtonProps extends ButtonProps {
  loading?: boolean
}

const SpinnerButton: React.FC<SpinnerButtonProps> = ({ children, loading = false, disabled, ...props }) => {
  return (
    <Button {...props} disabled={disabled || loading}>
      {loading ? <CircularProgress size={24} color="inherit" /> : children}
    </Button>
  )
}

export default SpinnerButton
